import { EventEmitter, Injectable } from '@angular/core';
// import { ConnectionBackend, Headers, Http, RequestOptions, RequestOptionsArgs, Response } from '@angular/http';
import { SessionStorage } from 'ngx-webstorage';
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { environment } from '../../../environments/environment';
import { throwError, BehaviorSubject, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class HttpService {
	@SessionStorage('auth') public authToken: any;
	public serverError: EventEmitter<Response> = new EventEmitter();
	public baseUrl: any = environment.url['wowUrl'];

	constructor(private http: HttpClient) {
	}
	get(api: any, app?): Observable<any> {
		if (app)
			this.baseUrl = environment.url[app];
		else
			this.baseUrl = environment.url['wowUrl'];
		return this.http
			.get(this.baseUrl + api, 
				{ headers: this.getRequestHeaders(true), observe: "response" }
			)
			.pipe(
				map(response => response),
				catchError(this.handleError)
			);
	}

	getIP(api: any): Observable<any> {
		return this.http
			.get(this.baseUrl + api, {
				headers: this.getRequestHeaders(true), observe: "response"
			})
			.pipe(
				map(response => response),
				catchError(this.handleError)
			);
	}

	// getLocal(url: string, options?: RequestOptionsArgs): Observable<any> {
	//     return super.get(url, options);
	// }

	/**
	 * Performs a request with `post` http method.
	 * @param url
	 * @param body
	 * @param options
	 * @returns {Observable<>}
	 */

	 fileDownload(query: any) {
    return this.http
      .get( this.baseUrl + query, {
        headers: this.getFileUploadHeader(),
        responseType: "text",
      })
      .pipe(
        map((response) => response),
        catchError(this.handleError)
      );
	}
	
	getFileUploadHeader(): HttpHeaders {
    let fileUploadHeader: HttpHeaders;
    return (fileUploadHeader = new HttpHeaders({
      "x-access-token": this.authToken.tokenType + " " + this.authToken.token,
    }));
	}
	
	filePostDownload(query: any, data: any,app?) {
		if (app)
			this.baseUrl = environment.url[app];
		else
			this.baseUrl = environment.url['wowUrl'];
    return this.http
      .post(this.baseUrl + query,JSON.stringify(data), {
        headers: this.getRequestHeaders(true),
        responseType: "blob",
      })
      .pipe(
        map((response) => response),
        catchError(this.handleError)
      );
  	}
	post(api: any, data: any, app?): Observable<any> {
		if (app)
			this.baseUrl = environment.url[app];
		else
			this.baseUrl = environment.url['wowUrl'];
		return this.http
			.post(this.baseUrl + api, JSON.stringify(data), {
				headers: this.getRequestHeaders(true), observe: "response"
			})
			.pipe(
				map(response => response),
				catchError(this.handleError)
			);
	}

	/**
	* Performs a request with `post` http method.
	* @param url
	* @param body
	* @param options
	* @returns {Observable<>}
	*/
	getHeaders(addToken?: boolean) {
			let headers: HttpHeaders = new HttpHeaders({
			platform: 'web',
			application: 'ihs'
		});
		// let headers: HttpHeaders = new HttpHeaders();
			if (this.authToken && this.authToken.tokenType && this.authToken.token && addToken) {
			headers = headers.append(
			"x-access-token",
			this.authToken.tokenType + " " + this.authToken.token
				);
		}
		return headers;
	}
	postApi(api: any, data: any,app?): Observable<any> {
		  if (app)
			this.baseUrl = environment.url[app];
		else
			this.baseUrl = environment.url['wowUrl'];
		return this.http
		.post(this.baseUrl + api, data, {
			headers: this.getHeaders(true),
			observe: "response",
		})
		.pipe(
			map((response) => response),
			catchError(this.handleError)
		);
	}
	upload(api: any, data: any, app?): Observable<any> {
		if (app)
			this.baseUrl = environment.url[app];
		else
			this.baseUrl = environment.url['wowUrl'];
		return this.http
			.post(this.baseUrl + api, data, {
				headers: this.getRequestUploadHeaders(), observe: "response"
			})
			.pipe(
				map(response => response),
				catchError(this.handleError)
			);
	}

	/**
	 * Performs a request with `put` http method.
	 * @param url
	 * @param body
	 * @param options
	 * @returns {Observable<>}
	 */
	put(api: any, data: any, app?): Observable<any> {
		if (app)
			this.baseUrl = environment.url[app];
		else
			this.baseUrl = environment.url['wowUrl'];
		return this.http
			.put(this.baseUrl + api, JSON.stringify(data), 
				{headers: this.getRequestHeaders(true), observe: "response"}
			
			)
			.pipe(
				map(response => response),
				catchError(this.handleError)
			);
	}

	/**
	 * Performs a request with `delete` http method.
	 * @param url
	 * @param options
	 * @returns {Observable<>}
	 */
	delete(api: any, app?): Observable<any> {
		if (app)
			this.baseUrl = environment.url[app];
		else
			this.baseUrl = environment.url['wowUrl'];
		return this.http
			.delete(this.baseUrl + api, 
				{headers: this.getRequestHeaders(true), observe: "response"}
			)
			.pipe(
				map(response => response),
				catchError(this.handleError)
			);
	}

	/**
	 * Request options.
	 * @param options
	 * @returns {RequestOptionsArgs}
	 */

	getPostRequestHeaders(): HttpHeaders {
		const headers: HttpHeaders = new HttpHeaders({
			'Content-Type': 'application/json',
			platform: 'web',
			application: 'ihs'
			// 'Connection': 'keep-alive',
			// 'Keep-Alive': 'timeout=200'
		});
		// include the autherisation header if it exitsts
		if (this.authToken) {
			headers.set('x-access-token', this.authToken.tokenType + ' ' + this.authToken.token);
		}
		return headers;
	}
	getRequestHeaders(addToken?: boolean): HttpHeaders {
		let headers: HttpHeaders = new HttpHeaders({
			'Content-Type': 'application/json',
			platform: 'web',
			application: 'ihs'
			// 'Connection': 'keep-alive',
			// 'Keep-Alive': 'timeout=200'
		});
		// include the autherisation header if it exitsts

		if (this.authToken && this.authToken.tokenType && this.authToken.token && addToken) {
			headers = headers.append(
				"x-access-token",
				this.authToken.tokenType + " " + this.authToken.token
			);
		
			
		}
		return headers;
	}


	getRequestUploadHeaders(): HttpHeaders {
		const headers: HttpHeaders = new HttpHeaders({
			platform: 'web',
			application: 'ihs'
		});
		// include the autherisation header if it exitsts
		if (this.authToken) {
			headers.set('x-access-token', this.authToken.tokenType + ' ' + this.authToken.token);
		}
		return headers;
	}
	handleError(error: any): Observable<any> {
		return throwError(error);
	}
}
